import Vue from 'vue'
// import { use } from 'vue/types/umd'
import App from './App'
import router from './router'
import store from './store'
import Vuex from 'vuex'
// import axios from 'axios'
import request from './utils/request'
import { Message } from 'element-ui'

import '../static/js/swiper-3.4.2.min';
import '../static/js/swiper-3.4.2.min.css';
import '../static/js/leftMenu.js';
import '../static/js/leftMenu.css';
import './assets/css/base/_fonts.scss'
import vueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(vueAwesomeSwiper);


import Vant from 'vant';
Vue.use(Vant)

Vue.prototype.$message = Message
Vue.config.productionTip = false
Vue.prototype.$ajax = request;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  Vuex,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js